import UserApi from "./UserApi";
class V3UserApi implements UserApi {
  fetchCustom: (
    url: string,
    options: any,
    addAuthenticationHeader?: boolean
  ) => Promise<any>;

  constructor(
    fetchC: (
      url: string,
      options: any,
      addAuthenticationHeader?: boolean
    ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  //create/update user based on phonenumber
  saveUserDetails = (user: any) => {
    const fetchUrl = `/customers`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(user)
      },
    );
  }

  checkBusinessId = (businessId: string) => {
    const fetchUrl = `/anonymous/verify-business-id?business-id=${encodeURIComponent(businessId)}`;
    return this.fetchCustom(fetchUrl, {});
  }

  fetchUser = (token?: string, jwt?: string) => {

    if (!token || !jwt) {
      return this.fetchCustom("/customers/me", {});
    }

    return this.fetchCustom('/customers/me', {
      headers: {
        Authorization: "Bearer " + token,
        jwt
      }
    }, false);
  };

  askNotificationsForAlerts = (vehicleId: string, startDate: string, endDate: string, email: string, route: string) => {
    const fetchUrl = `/anonymous/ask-notification`;

    const body = {
      email: email,
      vehicleId: vehicleId,
      startDate: startDate,
      endDate: endDate,
      route: route
    }
    return this.fetchCustom(
        fetchUrl,
        {
          method: "POST",
          body: JSON.stringify(body)
        },
    );
  }
}

export default V3UserApi;
